module.exports = __webpack_public_path__ + "static/img/can-raspberry.b1e71d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-raspberry.png
// module id = x+wA
// module chunks = 0